"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setSpecificitiesValuesToFormData = exports.setInitialSpecificitiesOfProductValues = exports.SpecificitiesOfProductFields = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _formik = require("formik");
var _RenderSection = require("./RenderSection");
var _moment = _interopRequireDefault(require("moment"));
var _lodash = _interopRequireDefault(require("lodash"));
var _useDidUpdateEffect = require("react-platform-components/dist/hooks/useDidUpdateEffect");
var _RenderSpecificities = require("./RenderSpecificities");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var CategoryOfProductField = null;
try {
  CategoryOfProductField = require('react-platform-category-of-product/dist/CategoryOfProduct/CategoryOfProductField').default;
} catch (error) {}

// We get the uuid of weight for use it to set the default_weight of category to the weight specificity
var WEIGHT_SPECIFICITY_UUID;
try {
  WEIGHT_SPECIFICITY_UUID = require('react-platform-shipping/dist/config').WEIGHT_SPECIFICITY_UUID;
} catch (error) {}
var setInitialSpecificitiesOfProductValues = function setInitialSpecificitiesOfProductValues(product) {
  var fieldName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "specificities";
  var _ref = arguments.length > 2 ? arguments[2] : undefined,
    specificities = _ref.specificities,
    categories = _ref.categories;
  if (!product) return _defineProperty({}, fieldName, null);
  // case when the we use category of product module
  if (CategoryOfProductField && product.category) {
    var selectedCategory = _lodash.default.find(categories, function (category) {
      return Number(category.id) === Number(product.category.id);
    });
    return _defineProperty({}, fieldName, selectedCategory ? _lodash.default.map(_lodash.default.uniqBy(selectedCategory.deep_category_specificities, 'specificity.id'), function (item) {
      return _objectSpread(_objectSpread(_objectSpread({
        choice: null
      }, item), _lodash.default.find(product.product_specificities, function (productSpecificities) {
        return Number(productSpecificities.specificity.id) === Number(item.specificity.id);
      })), {}, {
        specificity: _lodash.default.find(specificities, function (element) {
          return Number(element.id) === Number(item.specificity.id);
        })
      });
    }) : null);
  }
  // case without category of product module
  return _defineProperty({}, fieldName, _lodash.default.map(specificities, function (specificity) {
    return _objectSpread(_objectSpread({
      choice: null
    }, _lodash.default.find(product.product_specificities, function (productSpecificities) {
      return Number(productSpecificities.specificity.id) === Number(specificity.id);
    })), {}, {
      specificity: specificity
    });
  }));
};
exports.setInitialSpecificitiesOfProductValues = setInitialSpecificitiesOfProductValues;
var setSpecificitiesValuesToFormData = function setSpecificitiesValuesToFormData(formData) {
  var fieldName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "product_specificities";
  var data = arguments.length > 2 ? arguments[2] : undefined;
  var product = arguments.length > 3 ? arguments[3] : undefined;
  // specificities to be added
  var specificitiesToBeAdded = [];
  if (data.specificities && !_lodash.default.isEmpty(data.specificities)) {
    data.specificities.forEach(function (item, index) {
      specificitiesToBeAdded.push(item.specificity.id);
      if (item.choice) {
        formData.append("".concat(fieldName, "-").concat(index, "-specificity"), item.specificity.id);
        if (item.specificity.type === "date") {
          var hasTheRightFormat = (0, _moment.default)(item.choice, "YYYY-MM-DD", true).isValid();
          if (hasTheRightFormat) {
            formData.append("".concat(fieldName, "-").concat(index, "-date"), item.choice);
          } else {
            var date = (0, _moment.default)(item.choice, "DD-MM-YYYY").format("YYYY-MM-DD");
            formData.append("".concat(fieldName, "-").concat(index, "-date"), date);
          }
        } else if (item.specificity.type === "m_list") {
          formData.append("".concat(fieldName, "-").concat(index, "-choices"), item.choice.join("|"));
        } else if (item.specificity.type === "free") {
          formData.append("".concat(fieldName, "-").concat(index, "-free"), item.choice);
        } else if (item.specificity.type === "number") {
          formData.append("".concat(fieldName, "-").concat(index, "-number"), item.choice);
        } else if (item.specificity.type === "range") {
          formData.append("".concat(fieldName, "-").concat(index, "-range_min"), item.choice[0]);
          formData.append("".concat(fieldName, "-").concat(index, "-range_max"), item.choice[1]);
        } else if (item.specificity.type === "boolean") {
          formData.append("".concat(fieldName, "-").concat(index, "-boolchoice"), item.choice);
        } else if (item.specificity.type === "phone") {
          formData.append("".concat(fieldName, "-").concat(index, "-phone"), item.choice);
        } else if (item.specificity.type === "document") {
          // handle the deleted files
          var productSpecificity = _lodash.default.find(product.product_specificities, function (productSpecificity) {
            return productSpecificity.specificity.id === item.specificity.id;
          });
          if (productSpecificity) {
            _lodash.default.forEach(productSpecificity.choice || [], function (file) {
              if (!_lodash.default.find(item.choice || [], function (item) {
                return item.name === file.name;
              })) {
                formData.append("".concat(fieldName, "-").concat(index, "-files-delete-specific-files"), file.name);
              }
            });
          }
          if (_lodash.default.find(item.choice || [], function (item) {
            return item instanceof File;
          })) {
            // handle the new uploaded files
            _lodash.default.forEach(item.choice || [], function (item) {
              if (item instanceof File) {
                formData.append("".concat(fieldName, "-").concat(index, "-files"), item);
              }
            });
          } else {
            // we need to send files as empty if there no new file to upload
            formData.append("".concat(fieldName, "-").concat(index, "-files"), undefined);
          }
        } else {
          formData.append("".concat(fieldName, "-").concat(index, "-choice"), item.choice);
        }
      }
    });
  }
  // specificities to be deleted
  if (product.product_specificities && product.product_specificities.length > 0) {
    product.product_specificities.forEach(function (item, index) {
      var isFound = specificitiesToBeAdded.some(function (specificity) {
        return specificity === item.specificity.id;
      });
    });
  }
  delete data.specificities;
};
exports.setSpecificitiesValuesToFormData = setSpecificitiesValuesToFormData;
var SpecificitiesOfProductFields = function SpecificitiesOfProductFields(props) {
  var _useFormikContext = (0, _formik.useFormikContext)(),
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue;
  var specificities = (0, _reactRedux.useSelector)(function (state) {
    return state.specificityOfProductReducer.specificities;
  });
  var categories = (0, _reactRedux.useSelector)(function (state) {
    return state.categoryOfProductReducer ? state.categoryOfProductReducer.categories : null;
  });
  (0, _useDidUpdateEffect.useDidUpdateEffect)(function () {
    if (CategoryOfProductField && values.category !== "" && props.submitCount === 0 && !_lodash.default.isEmpty(values.specificities)) {
      addSpecificities();
    } else {
      if (CategoryOfProductField && values.category !== "" && props.submitCount !== 0 && !_lodash.default.isEmpty(values.specificities)) {
        var _values$specificities;
        if (((_values$specificities = values.specificities[0].category) === null || _values$specificities === void 0 ? void 0 : _values$specificities.id) !== values.category) {
          addSpecificities();
        }
      } else {
        if (CategoryOfProductField && values.category !== "" && props.submitCount !== 0 && _lodash.default.isEmpty(values.specificities)) {
          addSpecificities();
        }
      }
    }
  }, [values.category]);
  var sectionsListing = function sectionsListing() {
    var sections = [];
    specificities.map(function (specificity) {
      var filtre = sections.filter(function (item) {
        var _specificity$section;
        return (item === null || item === void 0 ? void 0 : item.id) === (specificity === null || specificity === void 0 ? void 0 : (_specificity$section = specificity.section) === null || _specificity$section === void 0 ? void 0 : _specificity$section.id);
      });
      if (filtre.length === 0) {
        sections.push(specificity === null || specificity === void 0 ? void 0 : specificity.section);
      }
    });
    return sections.filter(function (item) {
      return item !== null;
    }).sort(function (element, nextElement) {
      return element.position - nextElement.position;
    });
  };
  var specificitiesWithoutSections = function specificitiesWithoutSections() {
    if (!_lodash.default.isEmpty(values.specificities)) return _lodash.default.uniqBy(values.specificities.filter(function (item) {
      return !item.specificity.section;
    }), "specificity");
    return [];
  };
  var specificitiesWithoutSectionsListing = specificitiesWithoutSections();
  //specificities of the section passed as param

  var sections = sectionsListing();
  var addSpecificities = function addSpecificities() {
    var _selectedCategory$dee;
    // // Find selected category
    var selectedCategory = categories.find(function (item) {
      return item.id === values.category;
    });
    // Loop through deep_category_specificities param of the selected category
    // and add each category to the specificities form field
    setFieldValue("specificities", selectedCategory === null || selectedCategory === void 0 ? void 0 : (_selectedCategory$dee = selectedCategory.deep_category_specificities) === null || _selectedCategory$dee === void 0 ? void 0 : _selectedCategory$dee.map(function (item) {
      var specificity = _lodash.default.find(specificities, {
        id: item.specificity.id
      });
      return _objectSpread(_objectSpread(_objectSpread({
        choice: specificity.uuid === WEIGHT_SPECIFICITY_UUID ? selectedCategory.default_weight || null : null
      }, item), _lodash.default.find(props.product.product_specificities, function (specificity) {
        return specificity.specificity.id === item.specificity.id;
      })), {}, {
        specificity: specificity
      });
    }));
  };
  if (_lodash.default.isEmpty(values.specificities) || CategoryOfProductField && !_lodash.default.get(values, 'category')) return null;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, specificitiesWithoutSectionsListing.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement(_RenderSpecificities.RenderSpecificities, {
      key: index,
      conditionalSpecificities: props.conditionalSpecificities,
      fieldsDependToValueOfSpecificities: props.fieldsDependToValueOfSpecificities,
      productSpecificity: item,
      isMd: props.isMd
    });
  }), /*#__PURE__*/_react.default.createElement(_formik.FieldArray, {
    name: "specificities",
    render: function render() {
      return specificities && specificities.length > 0 && sections && sections.map(function (item, index) {
        return /*#__PURE__*/_react.default.createElement(_RenderSection.RenderSection, {
          key: index,
          item: item,
          fieldsDependToValueOfSpecificities: props.fieldsDependToValueOfSpecificities,
          conditionalSpecificities: props.conditionalSpecificities,
          isMd: props.isMd
        });
      });
    }
  }));
};
exports.SpecificitiesOfProductFields = SpecificitiesOfProductFields;